import * as React from "react";
import type { SVGProps } from "react";
const SvgSuccess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <circle cx={7} cy={7} r={7} />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.121 4.07c.1.095.105.255.01.357L5.984 9.92a.25.25 0 0 1-.36.005l-2.75-2.778a.255.255 0 0 1 0-.357.25.25 0 0 1 .354 0l2.569 2.593 4.97-5.305a.25.25 0 0 1 .354-.01"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSuccess;
